/**
 * Выбор агроцикла в правом верхнем углу страницы цикла — тот же элемент, что
 * на «Обзоре» и «Воде» (`ChoiceSelect`). Смена цикла — переход на его адрес;
 * параметры среза (дата, демо) едут с адресом.
 */
import { useLocation, useNavigate } from 'react-router-dom';
import { ChoiceSelect } from '../../ui/AnalysisControls';
import { defineMessages } from '../../../i18n/define';
import { useT } from '../../../i18n/hooks';

const m = defineMessages({
  label: { id: 'cycle.page.picker.label', defaultMessage: 'Агроцикл', description: 'Подпись поля выбора агроцикла в шапке страницы агроцикла' },
});

export interface CycleOption {
  key: string;
  name: string;
  note?: string;
}

export function CyclePicker({ value, options }: { value: string; options: CycleOption[] }) {
  const t = useT();
  const navigate = useNavigate();
  const location = useLocation();
  if (options.length === 0) return null;
  const known = options.some((o) => o.key === value);
  return (
    <div className="cycle-picker" data-guide="scope">
      <ChoiceSelect
        label={t(m.label)}
        value={known ? value : ''}
        options={(known ? options : [{ key: '', name: value }, ...options]).map((o) => ({ id: o.key, name: o.name, description: o.note }))}
        onChange={(key) => {
          if (key && key !== value) navigate(`/cycles/${encodeURIComponent(key)}${location.search}`);
        }}
      />
    </div>
  );
}
